import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { msg } from 'api';

export default class ShoppingListsForm extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    onAddNewShoppingList: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func.isRequired,
  }

  constructor() {
    super();
    this.handleAddNewShoppingList = this.handleAddNewShoppingList.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleAddNewShoppingList(e) {
    e.preventDefault();
    this.props.onAddNewShoppingList(this.props.value);
  }

  handleChange(e) {
    this.props.onChangeValue(e.target.value);
  }

  render() {
    const { value } = this.props;
    return (
      <form className="sl-modal__content--form form" onSubmit={this.handleAddNewShoppingList}>
        <h2>{msg.shoppingLists.newListFormHeader}</h2>
        <div className="sl-modal__content--input input">
          <input
            type="text"
            onChange={this.handleChange}
            value={value}
            name="new-list-name"
            placeholder="e.g. Essentials, Fajitas recipe..."
            autoComplete="on"
            aria-label="New list name"
          />
        </div>
        <div className="btn-wrapper sl-modal__content--submit">
          <button type="submit" className="btn-primary">
            Done
          </button>
        </div>
      </form>
    );
  }
}
